import { render } from "./PageNumber9.vue?vue&type=template&id=82a6437e&scoped=true"
import script from "./PageNumber9.vue?vue&type=script&lang=js"
export * from "./PageNumber9.vue?vue&type=script&lang=js"

import "./PageNumber9.vue?vue&type=style&index=0&id=82a6437e&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a6437e"]])

export default __exports__